import {
  GET_SALE_POINTS,
  convertResult,
  convertParams,
} from 'app/common/api/requests/food/schools/sale_points/get'

import { RequestSalePointsParams } from 'app/common/types/sale-points'

import { api } from 'app/api'

export const getSalePoints = async (params: RequestSalePointsParams, signal?: AbortSignal) => {
  const res = await api.request(GET_SALE_POINTS, {
    additionalAxiosOptions: {
      signal,
    },
    error: 'Не удалось получить данные точек продаж',
    params,
    convertions: {
      convertParams,
      convertResult,
    },
  })

  return res
}
